module.exports = __webpack_public_path__ + "img/information-outline.ed6701e7.svg";